export default __webpack_public_path__ + "static/media/change-link-img(1).538b5d5b.svg";